import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const ProductDetailsBiReportSection = "/reports/bi/product-details";

export const ProductDetailsBiReportListPath = ProductDetailsBiReportSection;

export enum ProductDetailsBiListUrlFiltersEnum {
  query = "query",
  updateFrom = "updateFrom",
  updateTo = "updateTo"
}
export enum ProductDetailsBiListUrlFiltersWithMultipleValues {
  productStatus = "productStatus"
}
export type ProductDetailsBiListUrlDialog =
  | "add"
  | "download"
  | TabActionDialog;
export type ProductDetailsBiListUrlFilters = Filters<
  ProductDetailsBiListUrlFiltersEnum
> &
  FiltersWithMultipleValues<ProductDetailsBiListUrlFiltersWithMultipleValues>;

export type ProductDetailsBiListUrlQueryParams = ActiveTab &
  ProductDetailsBiListUrlFilters &
  BulkAction &
  Dialog<ProductDetailsBiListUrlDialog> &
  Pagination &
  SingleAction;

export const ProductDetailsBiListUrl = (
  params?: ProductDetailsBiListUrlQueryParams
) => ProductDetailsBiReportListPath + "?" + stringifyQs(params);
